export function Tidy (pEditor)
{
  const fixTidyMultilineBug = (contentHTML) => contentHTML.replace(/(\S)\n/g, '$1 ');

  let tidyCurrentHTML,
      tidyCurrentCallBack;


  const tidyRequestSuccess = (data) =>
  {
    data = (data != null && data.content != null) ? data.content : tidyCurrentHTML;

    if (tidyCurrentCallBack)
    {
      tidyCurrentCallBack(data);
    }

    tidyCurrentHTML = null;
    tidyCurrentCallBack = null;
  };


  const tidyRequestFiled = (err) =>
  {
    if (tidyCurrentCallBack)
    {
      tidyCurrentCallBack(tidyCurrentHTML);
    }

    tidyCurrentHTML = null;
    tidyCurrentCallBack = null;
  };


  this.requestTidyService = (contentHTML, callBackFunction) =>
  {
    tidyCurrentHTML = contentHTML;
    tidyCurrentCallBack = callBackFunction;

    BEditor.services.getTidyContent(pEditor.extParameters.tidyServiceUrl, contentHTML, tidyRequestSuccess, tidyRequestFiled);
  };
}